<ng-container *transloco="let t">
  @if (iconOnly) {
    <button
      appearance="flat-grayscale"
      data-appearance="action"
      data-testid="description-icon"
      iconStart="@tui.text"
      size="s"
      stopPropagation
      tuiIconButton
      tuiTheme="dark"
      type="button"
      [tuiHint]="t('Description')"
      (click)="openSequenceDescription(descriptionDialog)"></button>
  } @else {
    <a
      data-appearance="action"
      data-testid="description"
      stopPropagation
      tuiLink
      (click)="openSequenceDescription(descriptionDialog)">
      {{ t('Description') }}
    </a>
  }

  <ng-template #descriptionDialog let-observer>
    <div class="flex flex-col gap-4">
      <p class="whitespace-pre-line">
        {{ description }}
      </p>
      <div class="flex justify-end gap-2">
        <button appearance="outline" tuiButton type="button" (click)="observer.complete()">
          {{ t('Fermer') }}
        </button>
      </div>
    </div>
  </ng-template>
</ng-container>
